<template>
  <div class="searchable__list">
      <div class="form__group">
          <div class="form__checkboxes">
              <SearchableListItem v-for="searchable in searchables"
                                  :searchable="searchable"
                                  :key="searchable.slug">
              </SearchableListItem>
          </div>
      </div>

  </div>
</template>

<script>
import {computed} from 'vue'
import {useStore} from "vuex";

import SearchableListItem from './SearchableListItem'

export default {
  name: 'SearchableList',
  components: {SearchableListItem},
  setup() {
    const store = useStore()
    const searchables = computed( () => (store.getters.searchables))

    return {
      searchables,
    }
  }
}
</script>

